import CustomImage from 'src/components/Image'

import useI18n from 'src/hooks/use_i18n'
import { AllCarriersInfoDTO } from 'src/types'
import { filterCarriersName } from 'src/utils/carriers_info'
import styles from './index.module.scss'

// 对名称比较长的运输商进行简写
const nameMap = {
  100308: 'Amazon',
  100001: 'DHL',
  100026: 'BRT',
  100007: 'DPD',
  100854: 'FedEx',
  100685: 'EMS',
  6051: 'La Poste',
  100552: 'BNI',
  100999: 'Purolator',
  7044: 'Deutsche',
  14044: 'PostNL',
  100597: 'Ninja'
}

export default function RecommendList({
  recommendList
}: {
  recommendList: (AllCarriersInfoDTO & { type: string; icon: string })[]
}) {
  const { activeLocale: locale, $t } = useI18n()

  return (
    <div className={styles.container}>
      <h2>{$t('ResWwwPlatform.global.__RecommendListTitle')}</h2>
      <p>{$t('ResWwwPlatform.global.__RecommendListSubTitle')}</p>
      <ul className={styles.recommendList}>
        {recommendList?.map(({ key, _name, type, icon }, index) => {
          return (
            <li key={index}>
              <a
                className={styles.recommendItem}
                href={`/${locale}/${type === 'brands' ? 'brands' : 'carriers'}/${filterCarriersName(_name)}`}
              >
                <CustomImage
                  src={`${type === 'brands' ? icon : `https://res.17track.net/asset/carrier/logo/120x120/${key}`}`}
                  width={64}
                  height={64}
                  loading="lazy"
                  isWebp={false}
                  alt={_name || ''}
                  errorSrc="https://res.17track.net/asset/carrier/logo/120x120/0"
                />
                <span>{nameMap[key] || _name}</span>
              </a>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
